import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginTypeConfig } from '../models/login/login-type-config.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class LoginTypeConfigService extends RequestService<LoginTypeConfig> {
  static PATH = '/om/loginTypeConfig';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, LoginTypeConfigService.PATH, globalService.debugUrl);
  }
}
